export enum JobType{
  FULL_TIME= 'FULL_TIME',
  PART_TIME= 'PART_TIME',
  CONTRACT= 'CONTRACT'
}
